// extracted by css-extract-rspack-plugin
export default {"comment-indicator":"SimpleDiff-module__comment-indicator__iwZDp"};